import { render, staticRenderFns } from "./incoming-sales-leads.vue?vue&type=template&id=2f18c60a&"
import script from "./incoming-sales-leads.vue?vue&type=script&lang=js&"
export * from "./incoming-sales-leads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports